import { PRIVATE_HTTP } from "./index";

const LIST_FLIGHT_COMMISSION_RULES = "api/settings/listflightcommissionrules";
const SET_FLIGHT_COMMISSION_RULE = "api/settings/setflightcommissionrule";

export var listFlightCommissionRules = (request) => {
   const promise = PRIVATE_HTTP().post(LIST_FLIGHT_COMMISSION_RULES, request);
   return promise.then((response) => {
      return response.data;
   });
};
export var setFlightCommissionRule = (request) => {
   const promise = PRIVATE_HTTP().post(SET_FLIGHT_COMMISSION_RULE, request);
   return promise.then((response) => {
      return response.data;
   });
};
